import { Popover as AntdPopover } from 'antd'
import { PopoverProps as Props } from 'antd/es/popover'
import { TooltipRef } from 'antd/es/tooltip'
import cx from 'classnames'
import React from 'react'
import './styles.scss'

export interface PopoverProps extends Props {
  children?: React.ReactNode
  theme?: 'dark' | 'light'
  hideArrow?: boolean
}

export const Popover = React.forwardRef<TooltipRef, PopoverProps>(
  ({ overlayClassName, children, content, theme, hideArrow, ...props }, ref) => (
    <AntdPopover
      ref={ref}
      {...props}
      content={content}
      overlayClassName={cx(
        'app-popover',
        { 'app-popover--dark': theme === 'dark', 'app-popover-arrow--hidden': hideArrow },
        overlayClassName
      )}
    >
      {children}
    </AntdPopover>
  )
)
Popover.displayName = 'Popover'
